
import { Component, Vue, Mixins } from "vue-property-decorator";
import { namespace } from 'vuex-class';
import { DispatchRequest, ScannerCheckInPayload, GuardCheckInPayload, DispatchType, GuardTourCheckInPayload, GuardCheckedInLocation, GuardCheckInResponse, WebAppInterface, ScanType } from "@/store/mobile/types";
import api from "@/services/api.mobile.service";
import DispatchMixin from "@/mixins/DispatchMixin";
import MobileMixin from "@/mixins/MobileMixin";

declare global {
	interface Window {
		checkInPayload: ScannerCheckInPayload;
		notificationSettings: any;
		android: WebAppInterface;
	}
}

const Mobile = namespace("mobile");

@Component
export default class ScanTypePicker extends Mixins(DispatchMixin, MobileMixin) {
    @Mobile.Mutation setManualLocationUpdate: (flag: boolean) => void;
    @Mobile.State(state => state.DispatchGuard.manualLocationUpdate) manualLocationUpdate: boolean;
    @Mobile.Action guardArrived: ({dispatchQueueId: number, hasArrived: boolean}) => Promise<void>;
	@Mobile.Mutation setNotificationText: (notificationText: string) => void;
	@Mobile.Getter("getActiveDispatchRequest") activeDispatchRequest: DispatchRequest;
	@Mobile.Getter("getGuardId") guardId: number;
 
    mounted() {
		const _this = this;

        Object.defineProperty(window, 'checkInPayload', {
            configurable: true,

            set (checkInPayload: ScannerCheckInPayload) {
				_this.checkGuardIn(checkInPayload);
            }
		})

		if (this.isLoadedInApp()) {
			var scanPayload: ScanType = {
					type: "qr",
				};
			if (this.isiOS()) {
				(window as any).webkit.messageHandlers.scannerRequestHandler.postMessage(scanPayload);
			} else if (this.isAndroid()) {
				const scanPayloadSerialized = JSON.stringify(scanPayload);
				window.android.scanRequest(scanPayloadSerialized);
			}
		}
    }

    destroyed() {
        Object.defineProperty(window, 'checkInPayload', {
            configurable: true,

            set () {}
		})
    }

    public async checkGuardIn(checkInPayload: ScannerCheckInPayload) {
		if (!checkInPayload || !this.activeDispatchRequest) {
			this.setNotificationText("Error: QR code cannot be processed");
			this.$emit("check-in-error");
			return;
		}

		if (checkInPayload.Cancelled) {
			this.$emit("check-in-error");
			return;
		}

		// If an error string is present, present it to user
		if (checkInPayload.Error && checkInPayload.Error.length > 0) {
			this.setNotificationText(checkInPayload.Error);
			this.$emit("check-in-error");
			return;
		}

		if (this.activeDispatchRequest.dispatchType == DispatchType.Dispatch) {
			const checkInRequestPayload: GuardCheckInPayload = {
				locationIdentifier: checkInPayload.Identifier,
				eventId: this.activeDispatchRequest.eventID,
				guardId: this.guardId,
			}

			api.dispatchedGuardCheckIn(checkInRequestPayload).then((response) => {
				this.updateGuardLocation(response.data);
			}).catch((error) => {
				if (error.response.status === 404) {
					this.setNotificationText("Error: Resource error on check in, contact operator.");
				} else {
					this.setNotificationText("Error: Error occurred during check in.");
				}
				this.$emit("check-in-error");
				return;
			})
		} else {
			const checkInRequestPayload: GuardTourCheckInPayload = {
				locationIdentifier: checkInPayload.Identifier,
				eventId: this.activeDispatchRequest.eventID,
				guardId: this.guardId,
				guardTourStepId: this.activeDispatchRequest.objectId,
			}

			api.guardTourStepCheckIn(checkInRequestPayload).then((response) => {
				this.updateGuardLocation(response.data);
			}).catch((error) => {
				if (error.response.status === 404) {
					this.setManualLocationUpdate(false);
					this.guardArrived({dispatchQueueId: this.activeDispatchRequest.dispatchQueueID, hasArrived: true});
				} else {
					this.setNotificationText("Error: Error occurred during check in.");
				}
				this.$emit("check-in-error");
				return;
			})
		}
	}
	
	public updateGuardLocation(checkInResponseData: GuardCheckInResponse) {
		if (!checkInResponseData) {
			this.setNotificationText("Error: Error occurred during check in.");
			this.$emit("check-in-error");
			return;
        }

		if (!this.manualLocationUpdate) {
			this.setManualLocationUpdate(true);
		}

		const guardLocation: GuardCheckedInLocation = {
			location: this.parseLocationToLatLng(checkInResponseData.latLong),
			minElevation: checkInResponseData.minElevation,
			maxElevation: checkInResponseData.maxElevation,
			isCorrectLocation: checkInResponseData.isCorrectLocation
		}

		if (checkInResponseData.isCorrectLocation) {
			this.guardArrived({dispatchQueueId: this.activeDispatchRequest.dispatchQueueID, hasArrived: true});
		}

		this.$emit("guard-checked-in", guardLocation);
	}
}
